import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IModelInfo } from "../../entities/nu-model-info";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";

export interface IPasteNodesOptions {
    selectedScenarioNames: string[];
    modelInfo: IModelInfo;
    clipboardText: string;
    targetPath: string;
}

@Component
export default class PasteNodesOptionsDialog extends Vue {


    @Prop()
    value: IPasteNodesOptions;


    onCancelClick() {
        this.$emit("dialogClosed", "cancel", this.value);

    }

    onOkClick() {
        var chooser = (this.$refs.scenarioChooser) as any;
        this.value.selectedScenarioNames = chooser.selectedScenarioNames as Array<string>;

        this.$emit("dialogClosed", "ok", this.value);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/paste-nodes-options-dialog/paste-nodes-options-dialog.ts